export const PROGRAMS_HI = {
  ai: {
    title: "आर्टिफिशियल इंटेलिजेंस (AI)",
    tagline: "पहले प्रॉम्प्ट से पहले मॉडल तक — छात्र ऐसा असली AI बनाते हैं जो देखता, बोलता और निर्णय लेता है।",
    outcomes: ["इमेज और वॉइस क्लासिफ़ायर ट्रेन करना", "चैटबॉट और AI असिस्टेंट बनाना", "स्थानीय समस्याओं पर AI का नैतिक उपयोग", "RoboSpark IoT उत्पादों में AI फीचर जोड़ना"],
    levels: [
      { grade: "कक्षा 6–8", name: "AI एक्सप्लोरर्स", topics: ["AI क्या है? पैटर्न और डेटा", "AI एक्सटेंशन के साथ ब्लॉक कोडिंग", "Teachable Machine से इमेज पहचान", "वॉइस असिस्टेंट और स्मार्ट स्पीकर", "मिनी प्रोजेक्ट: स्मार्ट अटेंडेंस काउंटर"] },
      { grade: "कक्षा 9–10", name: "AI बिल्डर्स", topics: ["Python की मूल बातें और डेटा", "मशीन लर्निंग: रिग्रेशन और क्लासिफिकेशन", "OpenCV से कंप्यूटर विज़न", "NLP की मूल बातें और चैटबॉट", "प्रोजेक्ट: फेस-रिकग्निशन डोर लॉक"] },
      { grade: "कक्षा 11–12", name: "AI इंजीनियर्स", topics: ["न्यूरल नेटवर्क और डीप लर्निंग", "Jetson Nano / Pi पर Edge AI", "जनरेटिव AI और प्रॉम्प्ट इंजीनियरिंग", "रोबोटिक्स और ड्रोन में AI (ऑटोनॉमी)", "कैपस्टोन: Roboshop के लिए AI उत्पाद"] },
    ],
  },
  robotics: {
    title: "रोबोटिक्स और ह्यूमनॉइड्स",
    tagline: "डिज़ाइन करें, जोड़ें, कोड करें और बेचें — छात्रों द्वारा बनाए रोबोट जो कक्षा से बाहर जाते हैं।",
    outcomes: ["लाइन-फॉलोअर, ऑब्स्टेकल और आर्म रोबोट बनाना", "सेंसर, मोटर और माइक्रोकंट्रोलर में महारत", "ह्यूमनॉइड और सर्विस रोबोट डिज़ाइन करना", "RoboSpark ब्रांड के तहत बिकने वाले रोबोट असेंबल करना"],
    levels: [
      { grade: "कक्षा 6–8", name: "रोबो स्टार्टर्स", topics: ["सर्किट, LED और ब्रेडबोर्ड", "Arduino की मूल बातें और ब्लॉक कोडिंग", "सेंसर: IR, अल्ट्रासोनिक, LDR", "लाइन फॉलोअर और ऑब्स्टेकल अवॉइडर", "प्रोजेक्ट: स्मार्ट डस्टबिन"] },
      { grade: "कक्षा 9–10", name: "रोबो मेकर्स", topics: ["मोटर ड्राइवर और PWM कंट्रोल", "ब्लूटूथ/Wi-Fi नियंत्रित रोबोट", "सर्वो के साथ रोबोटिक आर्म", "IoT होम ऑटोमेशन", "प्रोजेक्ट: घरेलू AI IoT किट"] },
      { grade: "कक्षा 11–12", name: "रोबो इंजीनियर्स", topics: ["काइनेमैटिक्स और कंट्रोल सिस्टम", "ROS और SLAM नेविगेशन", "ह्यूमनॉइड चाल और संतुलन", "होटल सर्विस रोबोट डिज़ाइन", "कैपस्टोन: व्यावसायिक रोबोट प्रोटोटाइप"] },
    ],
  },
  uav: {
    title: "UAV / ड्रोन टेक्नोलॉजी",
    tagline: "असेंबल करें, ट्यून करें और उड़ाएँ — भारत की तेज़ी से बढ़ती ड्रोन अर्थव्यवस्था के लिए पायलट और बिल्डर।",
    outcomes: ["उड़ान भौतिकी और एयरोडायनामिक्स समझना", "क्वाडकॉप्टर असेंबल और कैलिब्रेट करना", "ऑटोनॉमस मिशन प्रोग्राम करना", "DGCA ड्रोन करियर की तैयारी"],
    levels: [
      { grade: "कक्षा 6–8", name: "स्काई कैडेट्स", topics: ["चीज़ें कैसे उड़ती हैं: लिफ्ट, थ्रस्ट, ड्रैग", "ड्रोन के पुर्ज़े और सुरक्षा नियम", "सिम्युलेटर पर उड़ान अभ्यास", "मिनी ड्रोन इनडोर उड़ान", "प्रोजेक्ट: पेपर ग्लाइडर चैलेंज"] },
      { grade: "कक्षा 9–10", name: "ड्रोन बिल्डर्स", topics: ["ब्रशलेस मोटर, ESC और LiPo", "क्वाडकॉप्टर असेंबली (F450)", "फ्लाइट कंट्रोलर ट्यूनिंग", "FPV कैमरा और वीडियो लिंक", "प्रोजेक्ट: अपना ड्रोन बनाएँ और उड़ाएँ"] },
      { grade: "कक्षा 11–12", name: "UAV इंजीनियर्स", topics: ["GPS वेपॉइंट मिशन (Pixhawk)", "कृषि-स्प्रे और सर्वे ड्रोन", "ड्रोन पर कंप्यूटर विज़न", "ड्रोन नियम (DGCA)", "कैपस्टोन: मिशन-रेडी UAV"] },
    ],
  },
  aerospace: {
    title: "एयरोस्पेस इंजीनियरिंग",
    tagline: "रॉकेट, उपग्रह और उससे आगे — भारत के अगली पीढ़ी के अंतरिक्ष इंजीनियरों के लिए लॉन्चपैड।",
    outcomes: ["कक्षीय यांत्रिकी (orbital mechanics) की मूल बातें", "वॉटर/मॉडल रॉकेट बनाना और लॉन्च करना", "CanSat मिनी उपग्रह डिज़ाइन करना", "ISRO और स्पेस-टेक करियर जानना"],
    levels: [
      { grade: "कक्षा 6–8", name: "स्पेस एक्सप्लोरर्स", topics: ["सौर मंडल और अंतरिक्ष मिशन", "रॉकेट के साथ न्यूटन के नियम", "वॉटर रॉकेट बनाना और लॉन्च", "पैराशूट रिकवरी डिज़ाइन", "प्रोजेक्ट: बोतल रॉकेट प्रतियोगिता"] },
      { grade: "कक्षा 9–10", name: "रॉकेट मेकर्स", topics: ["एयरोडायनामिक्स और स्थिरता", "मॉडल रॉकेट सिमुलेशन (OpenRocket)", "सेंसर के साथ टेलीमेट्री", "विमान संरचना और सामग्री", "प्रोजेक्ट: टेलीमेट्री रॉकेट"] },
      { grade: "कक्षा 11–12", name: "एयरोस्पेस इंजीनियर्स", topics: ["कक्षीय यांत्रिकी और प्रणोदन", "CanSat उपग्रह डिज़ाइन", "ग्राउंड स्टेशन संचार", "स्पेस-टेक उद्यमिता", "कैपस्टोन: CanSat प्रतियोगिता प्रविष्टि"] },
    ],
  },
};

export const TESTIMONIALS_HI = [
  { name: "आरव कुमार", role: "कक्षा 10, पटना", text: "मैंने 6 हफ़्तों में अपना पहला ड्रोन बनाया — और हमारी टीम की IoT किट सच में Roboshop पर बिकी। मैंने अपने पहले ₹4,000 कमाए!" },
  { name: "श्रीमती सुनीता मिश्रा", role: "प्रधानाचार्य, रांची", text: "RoboSpark ने हमारे स्कूल में पूरी लैब स्थापित की। अब छात्र हर शनिवार का इंतज़ार करते हैं।" },
  { name: "राहुल सेन", role: "अभिभावक, कोलकाता", text: "मेरी बेटी खाने की मेज़ पर रॉकेट और उपग्रहों की बातें करती है। Learn & Earn मॉडल ने उसे असली आत्मविश्वास दिया।" },
];

export const CATEGORY_HI = {
  All: "सभी",
  "Microcontrollers & Boards": "माइक्रोकंट्रोलर और बोर्ड",
  Sensors: "सेंसर",
  "Motors & Servos": "मोटर और सर्वो",
  "Motor Drivers & ESCs": "मोटर ड्राइवर और ESC",
  "Power Supply": "पावर सप्लाई",
  "Drone & Robot Frames": "ड्रोन और रोबोट फ़्रेम",
  "Chassis & Frames": "चेसिस और फ्रेम",
  "Drone/UAV Specific": "ड्रोन/UAV पुर्ज़े",
  "Connectors & Misc": "कनेक्टर और अन्य",
  AI: "AI",
  Robotics: "रोबोटिक्स",
  UAV: "UAV",
  Aerospace: "एयरोस्पेस",
  Events: "कार्यक्रम",
};
